const mapsPerPage = 30

export { mapsPerPage }
